<div class="adding-area border-like-dx mg-b-10">

  <!-- Sélections cascadantes communes aux deux onglets -->
  <div class="line">
    <yo-tagbox
      [data]="clientList()"
      [selectedItems]="selectedClientIds()"
      (onValueChange)="onClientsChanged($event)"
      placeholder="Client"
      class="tagbox-item">
    </yo-tagbox>

    <yo-tagbox
      [data]="plcList()"
      [selectedItems]="selectedPlcIds()"
      (onValueChange)="onPlcsChanged($event)"
      [disabled]="!selectedClientIds().length"
      placeholder="Point de livraison"
      class="tagbox-item">
    </yo-tagbox>

    <yo-tagbox
      [data]="prestationList()"
      [selectedItems]="selectedPrestationIds()"
      (onValueChange)="onPrestationsChanged($event)"
      [disabled]="!selectedPlcIds().length"
      placeholder="Prestation"
      class="tagbox-item">
    </yo-tagbox>
  </div>

  <!-- Champs spécifiques : Jours -->
  @if (activeTab() === FermetureTabEnum.JOUR) {
    <div class="line mg-t-10">
      <yo-tagbox
        [data]="joursSemaineItems"
        [selectedItems]="selectedJours()"
        (onValueChange)="onJoursChanged($event)"
        [disabled]="!selectedPrestationIds().length"
        placeholder="Jours de fermeture"
        displayValue="label"
        key="value"
        class="tagbox-item tagbox-wide">
      </yo-tagbox>
    </div>
  }

  <!-- Champs spécifiques : Période -->
  @if (activeTab() === FermetureTabEnum.PERIODE) {
    <div class="line mg-t-10">
        <yo-date-range-box
          [selectedDates]="selectedDateRange()"
          [lastDateLastDay]="false"
          (onValueChange)="onDateRangeChanged($event)">
        </yo-date-range-box>
        <dx-select-box
          class="motif-select"
          [dataSource]="motifsFermetureResource.value() ?? []"
          displayExpr="libelle"
          valueExpr="id"
          [value]="selectedMotifId()"
          (onValueChanged)="onMotifChanged($event)"
          [disabled]="!selectedPrestationIds().length"
          placeholder="Motif de fermeture"
          [showClearButton]="true">
        </dx-select-box>
    </div>
  }

  <!-- Boutons -->
  <div class="custom-button-container-right mg-t-10">
    @if (activeTab() === FermetureTabEnum.JOUR) {
      <yo-button
        iconClass="fa fa-plus"
        label="Ajouter"
        tooltip="Générer les lignes de fermeture"
        [theme]="ButtonThemeEnum.ADD"
        [disabled]="!canAddJour()"
        (onClick)="addJour()">
      </yo-button>
    }
    @if (activeTab() === FermetureTabEnum.PERIODE) {
      <yo-button
        iconClass="fa fa-plus"
        label="Ajouter"
        tooltip="Générer les lignes de fermeture"
        [theme]="ButtonThemeEnum.ADD"
        [disabled]="!canAddPeriode()"
        (onClick)="addPeriode()">
      </yo-button>
    }
    <yo-button
      iconClass="fa fa-times"
      label="Fermer"
      tooltip="Fermer la zone d'ajout"
      [theme]="ButtonThemeEnum.CANCEL"
      (onClick)="closeRequested.emit()">
    </yo-button>
  </div>
</div>
